import { sendClickHouseAnalytic } from '@shared/api/analytics/template'

// Уникальные события для галереи новостей
export const EGGNewsGallery = {
  // 1. Отобразился экран
  appear_screen_page: () =>
    sendClickHouseAnalytic({
      event_name: 'screen_appear',
    }),
}
